import { useState, useCallback } from 'react';
import { ListItem } from 'common/types/common';

import { Dispatch, SetStateAction } from 'react';

export interface SelectState extends Partial<ListItem> {
  [key: string]: string | undefined; 
}
export type ChangeSelectState = (event: any, value: any) => void;
export type SetSelectState = Dispatch<SetStateAction<SelectState>>;

export const useSelectState = (initValue?: SelectState) => {
  const [value, setValue] = useState<SelectState>(() => (initValue || {}));

  const onChangeValue = useCallback((_: any, value: any) => {
    setValue(value || {});
  }, [setValue]);

  return [value, onChangeValue, setValue] as const;
};
